import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { useState, forwardRef } from 'react';
import { useGetUserQuery } from 'common';
import { userDateFormat } from 'services/time_format';
import { SectionContainer } from './section_container';
import { Spot } from './spot';
const daysContainerCss = "d1q4iz01";
const DaysContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(daysContainerCss, props.className)} />;
});
const DaysList = ({
  days,
  poll,
  isTopSpots = false
}) => {
  const {
    data: {
      timezone,
      dateNotation,
      locale
    }
  } = useGetUserQuery();
  return <DaysContainer>
      {days.map(([key, daySpots]) => <FlexLayout direction="column" gap={8} key={key}>
          <BodyText size="medium" weight="bold">
            {userDateFormat(moment(daySpots[0].startTime).tz(timezone), dateNotation, 'date_full', locale)}
          </BodyText>
          <div>
            {daySpots.map(spot => <Spot key={spot.startTime} spot={spot} poll={poll} isTopSpot={isTopSpots} />)}
          </div>
        </FlexLayout>)}
    </DaysContainer>;
};
const groupSpotsByDay = (spots, timezone) => {
  const daysMap = Object.groupBy(spots, ({
    startTime
  }) => moment(startTime).tz(timezone).startOf('day').unix());
  return Object.entries(daysMap).sort((a, b) => a[0] - b[0]);
};
export const TopTimes = ({
  poll
}) => {
  const {
    data: {
      timezone
    }
  } = useGetUserQuery();
  const spots = poll.topSpots;
  if (spots.length === 0) return null;
  const days = groupSpotsByDay(spots, timezone);
  return <FlexLayout direction="column" gap={16}>
      <BodyText size="large" weight="bold">{I18n.t('publisher.scheduling.polls.top_times.title')}</BodyText>
      <DaysList days={days} poll={poll} isTopSpots />
    </FlexLayout>;
};
const allTimesHeaderButtonCss = "affh1qp";
const AllTimesHeaderButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(allTimesHeaderButtonCss, props.className)} />);
const rowWithIconCss = "r1er1unt";
const RowWithIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rowWithIconCss, props.className)} />;
});
export const AllTimes = ({
  poll
}) => {
  const {
    data: {
      timezone
    }
  } = useGetUserQuery();
  const [isOpen, setOpen] = useState(false);
  const spots = poll.spots;
  if (spots.length === 0) return null;
  const days = groupSpotsByDay(poll.spots, timezone);
  const handleClick = () => setOpen(state => !state);
  return <>
      <AllTimesHeaderButton onClick={handleClick} aria-controls="all-days-list" aria-expanded={isOpen}>
        <RowWithIcon>
          <BodyText size="large" weight="bold">{I18n.t('publisher.scheduling.polls.all_times.title')}</BodyText>
          {isOpen ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />}
        </RowWithIcon>
        <BodyText size="medium" color="muted">
          {I18n.t('publisher.scheduling.polls.all_times.times', {
          count: spots.length
        })}
          {' '}
          {I18n.t('publisher.scheduling.polls.all_times.days', {
          count: days.length
        })}
        </BodyText>
      </AllTimesHeaderButton>
      <div id="all-days-list">
        {isOpen && <SectionContainer>
            <DaysList days={days} poll={poll} />
          </SectionContainer>}
      </div>
    </>;
};

require("./times.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./times.js");